import dayjs from 'dayjs';
import { IScheduleIntervalStore } from './scheduleInterval.interface';

export const SCHEDULE_INTERVAL_RESOURCE_TYPE = 'interval';

export const DAYJS_DATE_STUB = dayjs('2025-01-01');

export const scheduleIntervalInitialState: IScheduleIntervalStore = {
  data: {},
  loading: {},
};
